module.exports = require("mime-types");